import { render, staticRenderFns } from "./DeliveryPDF.vue?vue&type=template&id=2dcfd02b"
import script from "./DeliveryPDF.vue?vue&type=script&lang=js"
export * from "./DeliveryPDF.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPDF.vue?vue&type=style&index=0&id=2dcfd02b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports